import { render, staticRenderFns } from "./Cas.vue?vue&type=template&id=8f5e97ea&scoped=true"
import script from "./Cas.vue?vue&type=script&lang=js"
export * from "./Cas.vue?vue&type=script&lang=js"
import style0 from "./Cas.vue?vue&type=style&index=0&id=8f5e97ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5e97ea",
  null
  
)

export default component.exports